import api from '../api'
import { EmailTemplate } from './emailTemplateModel'

export const getEmailTemplates = async (): Promise<EmailTemplate[]> => {
  return (await api.get<EmailTemplate[]>('/web/email-templates')).data
}

export const saveEmailTemplate = async (emailTemplate: EmailTemplate): Promise<void> => {
  await api.post('/web/email-templates', emailTemplate)
}

export const deleteEmailTemplate = async (guid: string): Promise<void> => {
  await api.delete(`/web/email-templates/${guid}`)
}

